// extracted by mini-css-extract-plugin
export default {"utronLogo":"UtronLogo_utronLogo__a80HO"};